/**
 * Id of the inert JSON `<script>` the production build writes into index.html, listing the chunk
 * and stylesheet URLs the signed-in shell needs beyond the entry. Shared with vite.config.ts, so
 * this module must stay free of browser and app imports.
 */
export const SIGNED_IN_SHELL_ASSETS_ID = 'signed-in-shell-assets';
